import { ChecklistID } from "./Checklist";
import { DealerID } from "./Dealer";
import { DealerLocationID } from "./DealerLocation";
import { PublicAccount, PublicAccountID } from "./Publicaccount";
import { User, UserID } from "./User";

export type WebhookID = number;

export type WebhookHeaderID = number;

export type WebhookErrorID = number;

export enum WEBHOOK_TRIGGERS {
  CheckCreated = 1,
  OfferReady = 2,
  CustomerOK = 3,
  CarReady = 4,
  QualityCheck = 5,
  CommunicationFirst = 6,
  OnlineCheckinAvailable = 6,
  OnlineCheckinAnswered = 7,
  DiagnoseOverviewAvailable = 8,
  DiagnoseOverviewUpdateAvailable = 9,
  DiagnoseOverviewAnswered = 10,
  RepairOverviewAvailable = 11,
  RepairOverviewUpdateAvailable = 12,
  CommunicationLast = 12,
  CarInShop = 13,
  CarOutOfShop = 14,
  OnlineCheckInOpened = 15,
  DiagnoseOverviewOpened = 16,
  RepairOverviewOpened = 17,
  IsShopUpdated = 18,
  PublicAPIAppointmentImported = 19,
  DiagnoseStatus = 20,
  Snooze = 21,
  CustomerCommunicationSentByBirdWhatsApp = 22,
  User = 23
}

export interface WebhookTrigger {
  created_on: string;
  updated_on: string;
  id: WEBHOOK_TRIGGERS;
  name: string; // What is triggers the webhook to be sent
  description: string; // Description of the trigger and what action is required
}

export interface Webhook {
  created_on: string;
  updated_on: string;
  id: WebhookID;
  name: string; // Name of the webhook
  webhook_trigger_id: WEBHOOK_TRIGGERS; // TriggerID for the webhook, see the list of triggers in the enumeration section
  dealer_id: DealerID; // Dealer Identifier that created this Webhook
  dealer_location_id: DealerLocationID | null; // Location identifier
  public_account_id: PublicAccountID | null; // Public Account that created this Webhook
  user_id: UserID | null; // User that created this Webhook
  url: string; // URL to be called by the webhook
  queued: boolean; // This Webhook should be sent synchronously in a queue to the URL
  checklist_id: ChecklistID | null; // Checklist Identifier used to trigger a Check Created event, when not provided any Check will trigger it
  block_creating_support_ticket: boolean; // This Webhook will no longer notify support through tickets on errors
  active: boolean; // Whether webhook is active
  headers?: WebhookHeader[]; // webhook headers
  public_account?: PublicAccount;
  user?: User;
  has_recent_error?: boolean;
}

export interface WebhookHeader {
  created_on: string;
  updated_on: string;
  id: WebhookHeaderID;
  name: string;
  value: string;
  webhook_id: WebhookID;
  webhook?: Webhook;
}

export interface WebhookError {
  created_on: string;
  id: WebhookErrorID;
  webhook_id: WebhookID; // Webhook Identifier
  reason: string; // Reason for the error in webhook
}
